import React from "react";
import FooterContainer from "../components/footer/FooterContainer";
import HeaderContainer from "../components/header/HeaderContainer";
import FeatureContainer from "../components/feature/FeatureContainer";

export default function Home() {
  return (
    <>
      <HeaderContainer />
      <FeatureContainer />
      <FooterContainer />
    </>
  );
}
